var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"icp__input2",style:(("background-color: " + _vm.color)),attrs:{"type":"color"},domProps:{"value":_vm.color},on:{"input":_vm.handleInput,"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }